import type { ScreenerQuestion } from '../types/screener';

/**
 * Calculates the score for a single answered screener question.
 *
 * Priority: if the question carries `options` with explicit `optionvalue`,
 * use that (handles non-sequential scoring like 0,1,3,5). Otherwise fall
 * back to the index of the answer within `possibleanswers` (sequential 0-N).
 */
export function calculateQuestionScore(
  question: ScreenerQuestion,
  answer: string,
): number {
  const hasOptions = question.options && question.options.length > 0;

  if (hasOptions) {
    const matched = question.options!.find((opt) => opt.optiontext === answer);
    return matched ? Number(matched.optionvalue) || 0 : 0;
  }

  if (question.possibleanswers && question.possibleanswers.length > 0) {
    const idx = question.possibleanswers.indexOf(answer);
    return idx >= 0 ? idx : 0;
  }

  return 0;
}
